// First value is Make, second is model and this is year //
//-------------------------------------------------------//
// ------!!! FILTER FUNCTION USES PRODUCT-TAGS !!!------ //
// this means spaces will be removed &                   // see y-temp-test.liquid  line#325, 326:  year = year.replaceAll(" ", "");
// anything after and including ( will be removed        // see y-temp-test.liquid  line#327:  year = year.slice(0, year.indexOf("("));
// so 'Toyota' 'FJ Cruiser' '- 1st Gen' becomes--> 'Toyota'+'FJCruiser-1stGen'
var makeObject = {
 "Chevrolet": {
    "Colorado":       [//"- 1st Gen (04-12)",// None
                       "- 2nd Gen (15-22)",  // Done
                       "- 3rd Gen (2023+)"], // Done
   
    "Silverado 1500": [//"- 1st Gen (99-06)",
                       //"- 2nd Gen (07-13)",// Done
                       "- 3rd Gen (14-18)",  // Done
                       "- 4th Gen (2019+)"]  // Done
  },
 "Ford": {
    "Bronco":         [//"- 1st Gen (66-77)",
                       //"- 2nd Gen (78-79)",
                       //"- 3rd Gen (80-86)",
                       //"- 4th Gen (87-91)",
                       //"- 5th Gen (92-96)",
                       "- 6th Gen (2021+)", // Done
                       //"Raptor - 1st Gen (2022+)"],//
                      ],// Done
   
    "F-150":          [//"-  1st Gen (48-52)",
                       //"-  2nd Gen (53-56)",
                       //"-  3rd Gen (57-60)",
                       //"-  4th Gen (61-66)",
                       //"-  5th Gen (67-72)",
                       //"-  6th Gen (73-79)",
                       //"-  7th Gen (80-86)",
                       //"-  8th Gen (87-91)",
                       //"-  9th Gen (92-96)",
                       //"- 10th Gen (97-03)",
                       //"- 11th Gen (04-08)",
                       //"- 12th Gen (09-14)",
                       "- 13th Gen (15-20)",// Done
                       "- 14th Gen (2021+)",// Done
                       //"Raptor - 1st Gen (10-14)",
                       //"Raptor - 2st Gen (17-20)",
                       //"Raptor - 3st Gen (2021+)",
                      ],// Done
   
    "F-250":          [//"- 1st Gen (99-07)",
                       //"- 2nd Gen (08-10)",
                       //"- 3rd Gen (11-16)",
                       "- 4th Gen (17-19)", // Done
                       "- 5th Gen (20-21)", // Done
                       "- 6th Gen (2022+)"],// Done
   
    "F-350":          [//"- 1st Gen (99-07)",
                       //"- 2nd Gen (08-10)",
                       //"- 3rd Gen (11-16)",
                       "- 4th Gen (17-22)", // Done
                       "- 5th Gen (2023+)"],// Done
   
    "Ranger":         [//"- 1st Gen (83-92)",
                       //"- 2nd Gen (93-97)",
                       //"- 3rd Gen (98-11)",
                       "- 4th Gen (19-23)",//
                       "- 5th Gen (2024+)",//
                       //"Raptor - 1st Gen (2019+)",
                      ]
  },
 "Jeep": {
    //"Cherokee":     [],
    "Gladiator":      ["- 1st Gen (2020+)"],//JT Done
   
    "Wrangler":       ["- 1st Gen (87-95)", //YJ Done
                       "- 2nd Gen (96-06)", //TJ Done
                       "- 3rd Gen (07-17)", //JK Done
                       "- 4th Gen (2018+)"] //JL Done
  },
 "Lexus": {
    "GX":             ["470 - 1st Gen (03-09)", //Done
                       "460 - 2nd Gen (10-23)",//Done
                       //"550    - 3rd Gen (2024+)"],
                      ],
      
    "LX":             ["450  - 1st Gen (96-97)",//Done
                       "470  - 2nd Gen (97-07)",//Done
                       "570  - 3rd Gen (08-21)",//Done
                       //"450d - 3rd Gen (15-21)",//
                       //"600  - 4th Gen (2022+)"]//
                      ]
  },
 "Nissan": {
    "Frontier":       [//"- 1st Gen (98-04)", //None D22
                       "- 2nd Gen (05-21)", //Done D40
                       "- 3rd Gen (2022+)"],//Done D41
   
    /*"Titan":          ["- 1st Gen (04-15)", //
                       "- 2nd Gen (2016+)"],*/
   
    "Xterra":         ["- 1st Gen (99-04)", //Done
                       "- 2nd Gen (05-15)"] //Done
  },
 "Porsche": {
    "Cayenne":        ["- 1st Gen (03-10)" //Done
                       //"- 2nd Gen (11-18)",//None
                       //"- 3rd Gen (2019+)]"//None
                      ]
  },
 "RAM": {
    "1500":           [//"- 3rd Gen (02-08)", //Done
                       "- 4th Gen (09-18)", //Done
                       "- 5th Gen (2019+)"],//Done
   
    "2500":           ["- 4th Gen (10-13)", //Done
                       "- 4.5 Gen (14-18)", //Done
                       "- 5th Gen (2019+)"],//Done
   
    "3500":           [//"- 1st Gen ()",
                       //"- 2nd Gen (94-02)",
                       //"- 3rd Gen (03-09)",
                       "- 4th Gen (10-12)", //Done
                       "- 4.5 Gen (13-18)", //Done
                       "- 5th Gen (2019+)"] //Done
  },
 "Toyota": {
    "4Runner":        [//"- 1st Gen (84-89)", //None atm
                       "- 2nd Gen (90-95)", //Done
                       "- 3rd Gen (96-02)", //Done
                       "- 4th Gen (03-09)", //Done
                       "- 5th Gen (2010+)"],//Done
   
    "FJ Cruiser":     ["- 1st Gen (07-14)"],//Done +General
   
    "Land Cruiser":   [//"- 4th Gen (80-89)", //None atm
                       "- 5th Gen (90-97)", //Done
                       "- 6th Gen (98-07)", //Done
                       "- 7th Gen (08-21)", //Done
                       //"- 8th Gen (2024+)"],//None atm +General
                      ],
   
    "RAV4":           [//"- 1st Gen (96-00)", //None atm
                       "- 2nd Gen (01-05)", //Done
                       "- 3rd Gen (06-12)", //Done
                       "- 4th Gen (13-18)", //Done
                       "- 5th Gen (2019+)"],//Done +General
   
    "Sequoia":        ["- 1st Gen (01-07)", //Done
                       "- 2nd Gen (08-22)", //Done
                       "- 3rd Gen (2023+)"],//Done+

    "Tacoma":         ["- 1st Gen (95-04)", //Done
                       "- 2nd Gen (05-15)", //Done
                       "- 3rd Gen (16-23)", //Done
                       "- 4th Gen (2024+)"],//None (yet)+General
   
    "Tundra ":        ["- 1st Gen (00-06)", //Done
                       "- 2nd Gen (07-21)", //Done
                       "- 3rd Gen (2022+)"] //Done+General
  }
}